import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { ProtectedRoute } from "../../router/ProtectedRoutes";

const ManageUser = Loadable(
	lazy(() =>
		import("./UsersList/ManageUser").then(({ ManageUser }) => ({
			default: ManageUser,
		}))
	)
);

const ViewProfile = Loadable(
	lazy(() =>
		import("./ViewProfile/ViewProfile").then(({ ViewProfile }) => ({
			default: ViewProfile,
		}))
	)
);
const MyProfileView = Loadable(
	lazy(() =>
		import("./UsersList/MyProfileView").then(({ MyProfileView }) => ({
			default: MyProfileView,
		}))
	)
);

const UserBranch = Loadable(
	lazy(() =>
		import("../Profile/userBranch/UserBranchList").then(({ BranchList }) => ({
			default: BranchList,
		}))
	)
);

const ManageUserBranch = Loadable(
	lazy(() =>
		import("../Profile/userBranch/ManageUserBranch").then(
			({ ManageUserBranch }) => ({
				default: ManageUserBranch,
			})
		)
	)
);

const UserList = Loadable(
	lazy(() =>
		import("../Profile/UsersList/UsersList").then(({ UserList }) => ({
			default: UserList,
		}))
	)
);

export const profileRoutes = [
	{
		path: "/view-profile",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
				<ViewProfile />
			</AuthorizedRoute>
		),
	},
	{
		path: "/users/manage",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
				<ManageUser />
			</AuthorizedRoute>
		),
	},

	{
		path: "/users",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
				<UserList />
			</AuthorizedRoute>
		),
	},
	{
		path: "/users/manage/:userId",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USERS]}>
				<ManageUser />
			</AuthorizedRoute>
		),
	},

	{
		path: "/my-profile/:uuid",
		exact: true,
		element: (
			<ProtectedRoute>
				<MyProfileView />
			</ProtectedRoute>
		),
	},
	{
		path: "/user-branch",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USER_BRANCH]}>
				<UserBranch />
			</AuthorizedRoute>
		),
	},
	{
		path: "/user-branch/manage",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USER_BRANCH]}>
				<ManageUserBranch />
			</AuthorizedRoute>
		),
	},
	{
		path: "/user-branch/manage/:branchUUId",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.USER_BRANCH]}>
				<ManageUserBranch />
			</AuthorizedRoute>
		),
	},
];
